import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CreateOrderOutput, NotCreatedOrder, OrderOutput } from 'core/http/project';

@Component({
  selector: 'app-create-orders-result-dialog',
  templateUrl: './create-orders-result-dialog.component.html',
  styleUrls: ['./create-orders-result-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CreateOrdersResultDialogComponent {
  readonly accepted = new Array<OrderOutput>();
  readonly rejected = new Array<NotCreatedOrder>();

  constructor(@Inject(MAT_DIALOG_DATA) data: CreateOrderOutput) {
    this.accepted = data.accepted;
    this.rejected = data.rejected;
  }
}
